import {useEffect, useState} from 'react';

import {DialogActions, DialogContent} from '@mui/material';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';

import useReportParameters from '../../../../../hooks/providers/useReportParameters';
import Button from '../../../../form/buttons/Button/Button';
import BaseModal from '../../../../modal/BaseModal';
import Spinner from '../../../../spinner/Spinner';
import SingleUpdateHistoryBlock from '../SingleUpdateHistoryBlock/SingleUpdateHistoryBlock';

const HistoryModal = ({isOpen, onClose}) => {
  const [isLoading, setIsLoading] = useState(true);

  const {getDatasetRefreshesHistory, fullRefreshesHistory} = useReportParameters();

  useEffect(() => {
    if (!isOpen) return;

    const refreshesAlreadyFetched = fullRefreshesHistory?.length > 0;

    if (refreshesAlreadyFetched) {
      setIsLoading(false);
      return;
    }

    (async () => {
      setIsLoading(true);
      await getDatasetRefreshesHistory();
      setIsLoading(false);
    })();
  }, [isOpen, fullRefreshesHistory, getDatasetRefreshesHistory]);

  return (
    <BaseModal onClose={onClose} title="Historique des actualisations" open={isOpen}>
      <DialogContent sx={{p: 3}}>
        {isLoading ? (
          <Grid container alignItems="center">
            <Spinner isLoading text="Chargement de l'historique" />
          </Grid>
        ) : (
          <Grid>
            {(fullRefreshesHistory || []).map(h => (
              <SingleUpdateHistoryBlock key={h.refreshId} history={h} />
            ))}
          </Grid>
        )}
      </DialogContent>
      <DialogActions sx={{justifyContent: 'center'}}>
        <Button variant="outlined" color="primary" onClick={onClose}>
          Fermer
        </Button>
      </DialogActions>
    </BaseModal>
  );
};

HistoryModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default HistoryModal;
